/* Quiet horizontal rail: prev/next arrows + edge fades, no visible scrollbar.
   Click behaviour matches "Just Arrived" (sa-new-arrivals): a JS easeInOutCubic
   tween that advances ~2 cards so the motion is always visible (not a snap).
   Hooks every [data-rail-slider] containing a [data-rail] track. No deps. */
(function () {
  'use strict';

  function ease(p) { return p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; }

  function initRail(slider) {
    if (slider._saRailInit) return;
    slider._saRailInit = true;
    var rail = slider.querySelector('[data-rail]');
    if (!rail) return;
    var prev = slider.querySelector('[data-rail-prev]');
    var next = slider.querySelector('[data-rail-next]');
    var animating = false;

    function step() {
      var li = rail.querySelector('li');
      if (!li) return Math.round(rail.clientWidth * 0.5);
      var cs = getComputedStyle(rail);
      var gap = parseFloat(cs.columnGap || cs.gap) || 16;
      return Math.round((li.getBoundingClientRect().width + gap) * 2); // advance ~2 cards
    }

    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      var x = rail.scrollLeft;
      var scrollable = max > 2;
      slider.classList.toggle('is-scrollable', scrollable);
      slider.classList.toggle('can-prev', scrollable && x > 1);
      slider.classList.toggle('can-next', scrollable && x < max - 1);
    }

    // JS-driven tween so the slide is always VISIBLE; snap fights per-frame
    // scrollLeft writes, so disable it during the tween and restore after.
    function animateBy(delta) {
      var startLeft = rail.scrollLeft;
      var maxLeft = rail.scrollWidth - rail.clientWidth;
      var target = Math.max(0, Math.min(maxLeft, startLeft + delta));
      var distance = target - startLeft;
      if (!distance) return;
      var duration = 480, t0 = null;
      animating = true;
      rail.style.scrollSnapType = 'none';
      function frame(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / duration);
        rail.scrollLeft = Math.round(startLeft + distance * ease(p));
        if (p < 1) { requestAnimationFrame(frame); }
        else { rail.style.scrollSnapType = ''; animating = false; update(); }
      }
      requestAnimationFrame(frame);
    }

    if (prev) prev.addEventListener('click', function () { animateBy(-step()); });
    if (next) next.addEventListener('click', function () { animateBy(step()); });
    rail.addEventListener('scroll', function () { if (!animating) window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', function () { window.requestAnimationFrame(update); });

    update();
    window.setTimeout(update, 300);
  }

  function initAll() {
    var nodes = document.querySelectorAll('[data-rail-slider]');
    for (var i = 0; i < nodes.length; i++) initRail(nodes[i]);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
})();
